module.exports = __webpack_public_path__ + "static/mobile-submersible-pump-1ba4ef3f93c563cbf625e5fc6ee6ec35.png";